import { Category, Maybe } from "../generated/gql/graphql";

export const findRootCategoryById = (
  id: Maybe<string>,
  categories: Category[]
): string => {
  const category: Category | undefined = categories.find(
    (item) => item.id === id
  );

  if (category?.parentId) {
    return findRootCategoryById(category.parentId, categories);
  }

  return category?.name || "";
};
